<template>
    <div class="modal fade" id="partnerModal" tabindex="-1" role="dialog"
         aria-labelledby="partnerModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h1>{{page_header}}</h1>
                </div>
                <div class="modal-body">
                    <div class="row" style="position: relative">
                        <input class="modal-input" type="text" placeholder="PARTNER NAME" id="partnerModal--partner-name-input" v-model="partnerName"/>
                        <hr>
                        <div>
                            <avatar-upload contentText="PARTNER LOGO" ref="avatarUpload"></avatar-upload>
                        </div>
                        <hr>
                        <input class="modal-input" type="text" placeholder="PRIMARY DOMAIN" id="partnerModal--primary-domain-input" v-model="primaryDomain" style="text-transform: lowercase;"/>
                        <hr>
                        <div id="dvPartnerModalDropDown" v-show=true>
                            <dropdown :data="industryList"
                                      :cbChanged="changed"
                                      :width="350"
                                      :height="40"
                                      class="left-menu-partner-modal-drop-down dp"
                                      :placeholder="placeholder"
                                      :disabled="true"/>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="modal-footer-container">
                        <button class="modal-button modal-green-button grow" @click="saveClicked" id="partnerModal-save-button" v-if="!isEdit">SAVE
                        </button>
                        <button class="modal-button modal-green-button grow" @click="editClicked" v-if="isEdit">SAVE
                        </button>
                        <button class="modal-button modal-green-button grow" @click="deleteClicked" v-if="isEdit">
                            DELETE
                        </button>
                        <button class="modal-button modal-red-button grow" @click="cancelClicked">CANCEL</button>
                    </div>
                </div>
            </div>
        </div>
        <loading-modal v-if="loading"></loading-modal>
    </div>

</template>

<script>
    import LoadingModal from '@/components/modals/LoadingModal.vue'
    import AvatarUpload from '@/components/avatar-upload/AvatarUpload.vue'
    import Constants from '@/utils/constants'

    const DOMAIN_FORMAT = /^(([\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u02B0-\u02FF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u2000-\u206F\u2070-\u209F\u20A0-\u20CF\u20D0-\u20FF\u2100-\u214F\u2150-\u218F\u2190-\u21FF\u2200-\u22FF\u2300-\u23FF\u2400-\u243F\u2440-\u245F\u2460-\u24FF\u2500-\u257F\u2580-\u259F\u25A0-\u25FF\u2600-\u26FF\u2700-\u27BF\u27C0-\u27EF\u27F0-\u27FF\u2800-\u28FF\u2900-\u297F\u2980-\u29FF\u2A00-\u2AFF\u2B00-\u2BFF\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2E00-\u2E7F\u2E80-\u2EFF\u2F00-\u2FDF\u2FF0-\u2FFF\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31A0-\u31BF\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA720-\uA7FF\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uD800-\uDB7F\uDB80-\uDBFF\uDC00-\uDFFF\uE000-\uF8FF\uF900-\uFAFF\uFB00-\uFB4F\uFB50-\uFDFF\uFE00-\uFE0F\uFE10-\uFE1F\uFE20-\uFE2F\uFE30-\uFE4F\uFE50-\uFE6F\uFE70-\uFEFF\uFF00-\uFFEF\uFFF0-\uFFFF0-9]{1,})(-)?([\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u02B0-\u02FF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u2000-\u206F\u2070-\u209F\u20A0-\u20CF\u20D0-\u20FF\u2100-\u214F\u2150-\u218F\u2190-\u21FF\u2200-\u22FF\u2300-\u23FF\u2400-\u243F\u2440-\u245F\u2460-\u24FF\u2500-\u257F\u2580-\u259F\u25A0-\u25FF\u2600-\u26FF\u2700-\u27BF\u27C0-\u27EF\u27F0-\u27FF\u2800-\u28FF\u2900-\u297F\u2980-\u29FF\u2A00-\u2AFF\u2B00-\u2BFF\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2E00-\u2E7F\u2E80-\u2EFF\u2F00-\u2FDF\u2FF0-\u2FFF\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31A0-\u31BF\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA720-\uA7FF\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uD800-\uDB7F\uDB80-\uDBFF\uDC00-\uDFFF\uE000-\uF8FF\uF900-\uFAFF\uFB00-\uFB4F\uFB50-\uFDFF\uFE00-\uFE0F\uFE10-\uFE1F\uFE20-\uFE2F\uFE30-\uFE4F\uFE50-\uFE6F\uFE70-\uFEFF\uFF00-\uFFEF\uFFF0-\uFFFF0-9]{1,})?){1,}\.[\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u02B0-\u02FF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u2000-\u206F\u2070-\u209F\u20A0-\u20CF\u20D0-\u20FF\u2100-\u214F\u2150-\u218F\u2190-\u21FF\u2200-\u22FF\u2300-\u23FF\u2400-\u243F\u2440-\u245F\u2460-\u24FF\u2500-\u257F\u2580-\u259F\u25A0-\u25FF\u2600-\u26FF\u2700-\u27BF\u27C0-\u27EF\u27F0-\u27FF\u2800-\u28FF\u2900-\u297F\u2980-\u29FF\u2A00-\u2AFF\u2B00-\u2BFF\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2E00-\u2E7F\u2E80-\u2EFF\u2F00-\u2FDF\u2FF0-\u2FFF\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31A0-\u31BF\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA720-\uA7FF\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uD800-\uDB7F\uDB80-\uDBFF\uDC00-\uDFFF\uE000-\uF8FF\uF900-\uFAFF\uFB00-\uFB4F\uFB50-\uFDFF\uFE00-\uFE0F\uFE10-\uFE1F\uFE20-\uFE2F\uFE30-\uFE4F\uFE50-\uFE6F\uFE70-\uFEFF\uFF00-\uFFEF\uFFF0-\uFFFF0-9]{2,15}(\.[\u0000-\u007F\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u02B0-\u02FF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u2000-\u206F\u2070-\u209F\u20A0-\u20CF\u20D0-\u20FF\u2100-\u214F\u2150-\u218F\u2190-\u21FF\u2200-\u22FF\u2300-\u23FF\u2400-\u243F\u2440-\u245F\u2460-\u24FF\u2500-\u257F\u2580-\u259F\u25A0-\u25FF\u2600-\u26FF\u2700-\u27BF\u27C0-\u27EF\u27F0-\u27FF\u2800-\u28FF\u2900-\u297F\u2980-\u29FF\u2A00-\u2AFF\u2B00-\u2BFF\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2E00-\u2E7F\u2E80-\u2EFF\u2F00-\u2FDF\u2FF0-\u2FFF\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31A0-\u31BF\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA720-\uA7FF\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uD800-\uDB7F\uDB80-\uDBFF\uDC00-\uDFFF\uE000-\uF8FF\uF900-\uFAFF\uFB00-\uFB4F\uFB50-\uFDFF\uFE00-\uFE0F\uFE10-\uFE1F\uFE20-\uFE2F\uFE30-\uFE4F\uFE50-\uFE6F\uFE70-\uFEFF\uFF00-\uFFEF\uFFF0-\uFFFF0-9]{2,})?$/;
    export default {
        name: "partner-modal",
        components: {
            LoadingModal: LoadingModal,
            AvatarUpload: AvatarUpload
        },
        props: {},
        data() {
            return {
                loading: false,
                page_header: '',
                partnerName: null,
                primaryDomain: null,
                isEdit: false,
                partnerEnterpriseId: null,
                partnerPrimaryDomainId: null,
                industryList: [],
                setSelectedIndustry: null,
                currentSelectedIndustry: null,
                placeholder: null
            }
        },
        methods: {
            getUploadedFile() {

            },
            showModal(mode, partnerEnterpriseId, partnerName, partnerDomain, partnerLogo, primaryDomainId, partnerCurrentSelectedId) {
                if (mode === "edit") {
                    if(partnerCurrentSelectedId) {
                        this.placeholder = 'Loading...';
                    }
                    else {
                        this.placeholder = 'Select..';
                    }
                    this.industryList = [];
                    this.getIndustryList();
                    this.page_header = "EDIT PARTNER";
                    this.partnerName = partnerName;
                    this.primaryDomain = partnerDomain;
                    this.logo = partnerLogo;
                    this.$refs.avatarUpload.setAvatarData(this.logo);
                    this.isEdit = true;
                    this.partnerEnterpriseId = partnerEnterpriseId;
                    this.partnerPrimaryDomainId = primaryDomainId;
                    this.setSelectedIndustry = partnerCurrentSelectedId;
                    this.currentSelectedIndustry = partnerCurrentSelectedId;
                } else if (mode === "add") {
                    this.placeholder = 'Select..';
                    this.industryList = [];
                    this.getIndustryList();
                    // let setDefault = document.getElementsByClassName('selected');
                    // setDefault.value = 'Select..';
                    this.$refs.avatarUpload.setAvatarData(null);
                    this.page_header = "ADD PARTNER";
                    this.isEdit = false;
                    this.loading = false;
                    this.partnerName = null;
                    this.primaryDomain = null;
                    this.partnerPrimaryDomainId = null;
                    this.partnerEnterpriseId = null;
                    this.partnerLogo = null;
                    this.setSelectedIndustry = null;
                }
                else {
                    throw "Wrong Mode";
                }

                $('#partnerModal').modal('show');
            },
            hideModal() {
                $('#partnerModal').modal('hide');
            },
            saveClicked() {
                if(this.primaryDomain != undefined && this.primaryDomain != null && this.primaryDomain != ''
                    && DOMAIN_FORMAT.test(this.primaryDomain)){
                    this.loading = true;
                    this.$emit("saveClicked", {
                        partnerName: this.partnerName,
                        partnerLogo: this.$refs.avatarUpload.getAvatarData(),
                        primaryDomain: this.primaryDomain.toLowerCase(),
                        partnerIndustry: this.setSelectedIndustry
                    })
                }
                else {
                    this.$toasted.show('Primary domain should not be empty or valid domain!', {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                }

            },
            cancelClicked() {
                $(".settings-input").val("");
                $('#partnerModal').modal('hide');
                this.loading = false;
                this.clearData();
            },
            clearAndHideModal() {
                $(".settings-input").val("");
                $('#partnerModal').modal('hide');
                this.clearData();
            },
            clearData() {
                this.loading = false;
                this.partnerName = null;
                this.primaryDomain = null;
                this.partnerPrimaryDomainId = null;
                this.partnerEnterpriseId = null;
                this.page_header = '';
                this.partnerLogo = null;
                this.setSelectedIndustry = null;
                this.$refs.avatarUpload.setAvatarData(null);
            },
            editClicked() {
                this.loading = true;
                var str = this.partnerName.replace(/\(Partner Account\)/g,'');
                this.partnerName = str.trim();
                this.$emit("editClicked", {
                    partnerName: this.partnerName,
                    partnerLogo: this.$refs.avatarUpload.getAvatarData(),
                    primaryDomain: this.primaryDomain.toLowerCase(),
                    partnerEnterpriseId: this.partnerEnterpriseId,
                    partnerPrimaryDomainId: this.partnerPrimaryDomainId,
                    new_selected_industry_id: this.setSelectedIndustry,
                    current_selected_industry_id: this.currentSelectedIndustry
                })
            },
            deleteClicked() {
                this.loading = true;
                this.$emit("deleteClicked", {
                    partnerEnterpriseId: this.partnerEnterpriseId
                })
            },
            getIndustryList() {
                this.$http.get(Constants.INTELLIGENCE_BACKEND_URL + '/industry_list')
                    .then(response => {
                        // this.industryList = response.body.data;
                        response.body.data.forEach(d => {
                            var data = {
                                label: d['name'],
                                value: d['id'],
                                selected: (parseInt(d['id']) == parseInt(this.setSelectedIndustry))
                            };
                            this.industryList.push(data);
                        });

                    }, response => {

                    });
            },
            changed(selected) {
                if (selected[0].value != undefined && selected[0].value != null)
                    this.setSelectedIndustry = selected[0].value;
            }


        },
        computed: {},
        mounted() {
            // this.getIndustryList();
            $('#partnerModal').modal({show: false});
        }
    }
</script>

<style scoped>
    .modal-footer-container {
        width: 310px;
    }

    #dvPartnerModalDropDown {
        margin-bottom: 10px;
        background-color: #80d700;
        width: 350px;
        height: 40px;
        margin: 0 auto;
    }

    .hsy-dropdown > .selected {
        border-radius: 3px !important;
        padding: 0 30px 0 10px !important;
        color: white !important;
        cursor: pointer !important;
        background: url("../../assets/menu-arrow.svg") no-repeat 100% !important;
        background-position-x: calc(75% - 10px) !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        border: 0 !important;
        align-items: flex-start !important;
        text-align: left !important;
        line-height: 40px !important;
        font-size: 14px !important;
        max-height: 40px !important;
        height: 40px !important;
        width: 350px !important;
        font-family: 'Digital-Serial-Bold' !important;
    }

    .hsy-dropdown > .list .item {
        height: 40px !important;
        line-height: 40px !important;
        padding: 0 10px !important;
        cursor: pointer !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
        background-position: 5px !important;
        text-align: left !important;
        margin-bottom: 1px !important;
        color: white !important;
        border-bottom: 1px solid #00fea9 !important;
        font-size: 14px !important;
        font-family: 'Digital-Serial-Bold' !important;
    }

    .hsy-dropdown > .list .item:nth-of-type(odd) {
        background-color: #0a0b0c !important;
    }

    .hsy-dropdown > .list .item:nth-of-type(even) {
        background-color: rgb(16, 20, 26) !important;
    }

    .hsy-dropdown > .list {
        position: absolute !important;
        top: 35px !important;
        left: 0 !important;
        font-size: 1.2em !important;
        box-shadow: 0 0 5px rgba(0, 0, 0, .2) !important;
        border-radius: 1px !important;
        z-index: 100 !important;
        background-color: black !important;
        border: 1px solid #00fea9 !important;
        font-family: 'Digital-Serial-Bold' !important;
        max-height: 300px !important;
        overflow-y: auto !important;
    }

    .hsy-dropdown > .list .item.selected {
        background: #00fea9 no-repeat 10px !important;
        border-radius: 3px !important;
        color: black !important;
        padding-left: 20px !important;
        width: 100% !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
    }

    .hsy-dropdown > .list > .inner {
        padding: 2px 2px 0px 2px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/PartnerModal.vue